import React from 'react'
import styles from './FilePreview.module.scss'

const VolumeIcon = () => {
    return (
        <svg className={styles.volumeIcon} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250.91 263.36">

            <path d="M121.28,104.93c2.74,8.58,4.16,17.59,4.18,26.59.02,8.99-1.35,17.98-4.05,26.56l17.95,22.54c7.36-15.25,11.21-32.17,11.19-49.1-.03-16.91-3.92-33.8-11.3-49.01l-17.97,22.41" />
            <polyline points="100.36 6.07 29.8 93.89 0 93.89 0 169.16 29.8 169.16 100.36 256.98 100.36 6.08" />
            <path d="M172.74,40.58l-16.41,20.58c12.53,21.19,19.27,45.76,19.31,70.37.04,24.7-6.67,49.37-19.21,70.65l16.51,20.6c18.04-26.76,27.85-58.98,27.8-91.25-.06-32.19-9.94-64.3-27.99-90.96" />
            <path d="M205.24,0l-16.03,20.09c23.59,32.02,36.62,71.68,36.62,111.44s-13.03,79.42-36.62,111.44l16.13,20.39c29.29-37.23,45.62-84.46,45.58-131.82-.05-47.28-16.41-94.4-45.67-131.53" />
        </svg>
    )
}

export default VolumeIcon
